import { logToConsole } from './logToConsole';
import { config } from '../../config/config';
import { ERROR } from '../../constants/LogLevels';
import { transformObjectToKeyValueArray } from '../helpers/transformObjectToKeyValueArray';
import { transformErrorToObject } from '../helpers/transformErrorToObject';
import { Payload } from '../../types/payload';
import { LogRequest } from '../../types/logRequest';
import { LogLevel } from '../../types/logLevel';

let timeout: NodeJS.Timeout | string | number | undefined;
const buffer: LogRequest[] = [];

const resetTimeout = () => {
  if (timeout) {
    clearTimeout(timeout);
  }
};

const flushQueue = () => {
  const bufferLength = buffer.length;

  const requestOptions = {
    body: JSON.stringify({ logs: buffer }),
    method: 'POST',
    keepalive: true,
    headers: {
      'content-type': 'application/json',
    },
  };

  fetch(`${config.endpoint}/bulk`, requestOptions)
    .then(() => {
      buffer.splice(0, bufferLength);
    })
    .catch((error) => {
      logToConsole(ERROR, 'logging an error failed.', error);
    });
};

const setInitialTimeout = () => {
  resetTimeout();

  timeout = setTimeout(flushQueue, config.batchTimeout);
};

const generateLogRequest = (message: string, level: LogLevel, payload: Payload = {}) => {
  const transformedPayload = transformErrorToObject(payload);

  if (!transformedPayload.message) {
    // We want every log to include an 'mdc.payload_message'
    // field (not to be confused with 'message') for Dashboard construction.
    transformedPayload.message = message;
  }

  const location = typeof window !== 'undefined' ? window.location : undefined;

  return {
    message,
    level,
    application: config.application,
    timestamp: Date.now(),
    payload: transformObjectToKeyValueArray({
      ...config.defaultMetadata,
      ...transformedPayload,
      sessionId: config.sessionId,
      origin: location?.origin,
      pathname: location?.pathname,
    }),
  };
};

export const logToServer = (level: LogLevel, message: string, payload: Payload = {}) => {
  setInitialTimeout();

  buffer.push(generateLogRequest(message, level, payload));

  if (buffer.length >= config.batchSize) {
    resetTimeout();
    flushQueue();
  }
};
